import { createContext } from "react";

export const CartContext = createContext()
export const ProductContext = createContext()
export const DarkModeContext = createContext()